module.exports = __webpack_public_path__ + "static/media/modalRelatedLink.249fcd6c.svg";